import styled from 'styled-components'

export const BowTieStyledContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;

    svg#bowtie-svg {
        background: ${({ theme }) => theme['gray-200']};
        cursor: move;

        #bowtie-container {
            .hazardLine {
                stroke: ${({ theme }) => theme['yellow-500']};
                stroke-width: 2px;
                stroke-dasharray: 5 5;
                opacity: 0.5;
            }

            .hazardAuxLine {
                stroke: ${({ theme }) => theme['gray-400']};
                stroke-width: 2px;
                stroke-dasharray: 5 5;
                opacity: 0.5;
            }
        }
    }
`

export const ShowFrequencyButton = styled.button`
    position: absolute;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    bottom: 25px;
    left: calc(50% + 134px);
    border-radius: 5px;
    border: 1px solid ${({ theme }) => theme['gray-400']};
    transform: translateX(-50%);
    background: ${({ theme }) => theme['gray-100']};
    padding: 16px;
    gap: 8px;
    overflow: hidden;

    i {
        color: ${({ theme }) => theme['blue-700']};
    }
`
